import FlexPane from './_flex-pane.js'
import SportGroupsListController from './_sport-groups-list-controller.js'

export default {
  name: 'OutrightsView',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          padding: '8px 0 0 0',
        },
      },
    },
    topLeagues: {
      configSet: SportGroupsListController,
      configValues: {
        sportGroupsListView: {
          skeletonLoader: {
            disableLoader: false,
          },
        },
      },
    },
    allLeagues: {
      configSet: SportGroupsListController,
      configValues: {
        sportGroupsListView: {
          skeletonLoader: {
            disableLoader: false,
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
